<template>
  <div class="header" id="header" :class="{ 'hide': isHeaderHidden }">
    <div class="flex-row align-center justify-between tab">
      <img class="header-logo" src="/static/img/logo.png" @click="goIndex"/>

      <ul class="flex-row menu" :class="selectedLanguage == 'zh' ? 'menu-zh' : 'menu-en'">
        <router-link tag="li" to="/home/index" active-class="active-class">{{$t("menu.l1")}}</router-link>
        <router-link tag="li" to="/home/about" active-class="active-class">{{$t("menu.l2")}}</router-link>
        
        <!-- 裕林科技板 二级菜单 -->
        <router-link 
          tag="li" 
          to="/home/yulin/0" 
          active-class="active-class" 
          style="text-align: center; position: relative;"
          @mouseenter.native="showSceneSubMenu"
          @mouseleave.native="hideSceneSubMenu"
          :class="{ 'menu-item-active': sceneSubMenuVisible }">
          <span class="menu-main-text">
            {{$t("menu.l3")}}
            <span class="menu-badge new">NEW</span>
          </span>
          
          <!-- 优化后的简单下拉二级菜单 -->
          <transition name="menu-slide">
            <div class="simple-menu-container"
              v-show="sceneSubMenuVisible" 
              @mouseenter="showSceneSubMenu"
              @mouseleave="hideSceneSubMenu">
              <div class="simple-menu-content">
                <router-link
                  v-for="(item, index) in sceneItems"
                  :key="item.id"
                  :to="getSceneRoute(item.index)"
                  class="simple-menu-item"
                  :class="{ 'first-item': index === 0, 'last-item': index === sceneItems.length - 1 }">
                  <div class="menu-item-content">
                    <div class="menu-item-icon" :class="item.iconClass">
                      <span class="icon-symbol">{{ item.icon }}</span>
                    </div>
                    <div class="menu-text-wrapper">
                      <span class="simple-menu-name">
                        {{ selectedLanguage == 'zh' ? item.nameZh : item.nameEn }}
                      </span>
                      <span class="menu-desc">
                        {{ selectedLanguage == 'zh' ? item.descZh : item.descEn }}
                      </span>
                    </div>
                    <div class="item-badge" :class="item.badge" v-if="item.badge">
                      {{ item.badge }}
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </transition>
        </router-link>

        <!-- 产品定制中心 二级菜单 -->
        <router-link 
          tag="li" 
          to="/home/product" 
          active-class="active-class" 
          style="text-align: center;"
          @mouseenter.native="showSubMenu"
          @mouseleave.native="hideSubMenu">
          <span>{{$t("menu.l4")}}</span>
          
          <!-- 大背景图二级菜单 -->
          <transition name="el-zoom-in-top">
            <div class="mega-menu-container"
              v-show="subMenuVisible" 
              @mouseenter="showSubMenu"
              @mouseleave="hideSubMenu">
              <div class="mega-menu-content">
                <div class="mega-menu-grid">
                  <router-link
                    v-for="item in menuItems"
                    :key="item.command"
                    :to="getRoute(item.command)"
                    class="mega-menu-item"
                    :style="{ backgroundImage: 'url(' + item.bgImage + ')' }">
                    <div class="mega-menu-overlay"></div>
                    <span class="mega-menu-name">
                      {{ selectedLanguage == 'zh' ? item.nameZh : item.nameEn }}
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </transition>
        </router-link>

        <router-link tag="li" to="/home/news" active-class="active-class">{{$t("menu.l6")}}</router-link>
        <router-link tag="li" to="/home/join" active-class="active-class">{{$t("menu.l7")}}</router-link>
      </ul>
      
      <div class="language flex-between-center">
        <p :style="selectedLanguage == 'zh' ? '' : 'opacity: 0.6;'" @click="change('zh')">中文</p>
        <p class="separate">|</p>
        <p :style="selectedLanguage == 'en' ? '' : 'opacity: 0.6;'" @click="change('en')">EN</p>
      </div>
    </div>
  </div>
</template>

<script>
  import pubsub from 'pubsub-js'
  import product from '@/assets/json/product.json'

  import { setup } from "../../locales"

  export default {
    data() {
      return {
        selectedLanguage: localStorage.getItem('lindemanLocaleLanguage') ? localStorage.getItem('lindemanLocaleLanguage') : 'zh',

        isHeaderHidden: false,
        lastScrollPosition: 0,

        subMenuVisible: false,
        menuItems: product.menuItems,

        // 应用场景菜单数据
        sceneSubMenuVisible: false,
        sceneItems: [
          {
            index: 0,
            nameZh: '房车应用',
            nameEn: 'RV Application',
            descZh: '专业房车解决方案',
            descEn: 'Professional RV Solutions',
            icon: '🚐',
            iconClass: 'icon-rv-bg',
            badge: 'hot'
          },
          {
            index: 1, 
            nameZh: '家居定制',
            nameEn: 'Home Customization',
            descZh: '个性化家居定制',
            descEn: 'Personalized Home Solutions',
            icon: '🏠',
            iconClass: 'icon-home-bg',
            badge: 'new'
          }
        ]
      }
    },

    watch: {
      // 监听路由变化，当路由变化时收起菜单
      '$route'() {
        this.hideSubMenu()
        this.hideSceneSubMenu()
      }
    },

    mounted() {
      setup(this.selectedLanguage)

      // 鼠标上下滚动展示或隐藏导航栏
      window.addEventListener('scroll', this.handleScroll)
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
    },

    methods: {
      // 跳转首页
      goIndex(){
        this.$router.push({
          path: 'index',
          query: {
            key: Math.random()
          }
        })
      },
      change(language){
        this.selectedLanguage = language
        setup(language)
        pubsub.publish('lindemanLocaleLanguage', language)
      },

      // 产品菜单方法
      showSubMenu() {
        this.subMenuVisible = true
      },
      hideSubMenu() {
        this.subMenuVisible = false
      },

      // 应用场景菜单方法
      showSceneSubMenu() {
        this.sceneSubMenuVisible = true
      },
      hideSceneSubMenu() {
        this.sceneSubMenuVisible = false
      },

      // 裕林科技板应用场景路由
      getSceneRoute(sceneIndex) {
        return `/home/yulin/${sceneIndex}`
      },

      // 产品定制中心路由
      getRoute(spaceIndex) {
        return `/home/product?spaceIndex=${spaceIndex}`
      },

      handleScroll() {
        const current = window.pageYOffset
      
        // 向下滚动超过50px时隐藏
        if (current > this.lastScrollPosition && current > 50) {
          this.isHeaderHidden = true
        } 
        // 向上滚动时显示
        else if (current < this.lastScrollPosition) {
          this.isHeaderHidden = false
        }
        
        this.lastScrollPosition = current
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../static/css/pc/header.scss';
</style>

<style scoped>
  /* 大背景图二级菜单样式 */
  .mega-menu-container {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    width: 90%;
    background-color: white;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
    z-index: 300;
    border-radius: 4px;
    overflow: hidden;
    margin-top: 5px;
  }

  .mega-menu-content {
    padding: 50px;
  }

  .mega-menu-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 60px;
  }

  .mega-menu-item {
    width: 200px;
    aspect-ratio: 16 / 9;
    background-size: cover;
    background-position: center;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    display: block;
    transition: transform 0.3s, box-shadow 0.3s;
    text-decoration: none;
  }

  .mega-menu-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }

  .mega-menu-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0) 100%);
    opacity: 0.9;
    transition: opacity 0.3s;
  }

  .mega-menu-item:hover .mega-menu-overlay {
    opacity: 0.7;
  }

  .mega-menu-name {
    position: absolute;
    top: 45%;
    left: 0;
    width: 100%;
    text-align: center;
    color: white;
    font-size: 16px;
    padding: 0 15px;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
  }

  .mega-menu-item:hover .mega-menu-name {
    bottom: 25px;
    font-size: 20px;
  }

  /* 优化后的简单下拉菜单样式 */
  .menu-item-active {
    background: rgba(102, 126, 234, 0.1);
    border-radius: 6px;
    margin: 0 4px;
  }

  .menu-main-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
    position: relative;
    padding: 0 8px;
  }

  /* 菜单角标样式 - 右上角 */
  .menu-badge {
    position: absolute;
    top: -5px;
    right: -30px;
    font-size: 10px;
    padding: 3px 8px;
    border-radius: 8px;
    font-weight: 700;
    line-height: 1;
    background-color: #667eea; /* 使用菜单文字颜色 */
    color: white;
    transform: scale(0.8);
  }

  .simple-menu-container {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    background: white;
    box-shadow: 
      0 12px 32px rgba(0, 0, 0, 0.15),
      0 4px 16px rgba(0, 0, 0, 0.08);
    z-index: 300;
    border-radius: 12px;
    overflow: hidden;
    margin-top: 8px;
    min-width: 210px;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }

  .simple-menu-content {
    padding: 8px 0;
  }

  .simple-menu-item {
    display: block;
    text-decoration: none;
    color: #2d3748;
    transition: all 0.3s ease;
    position: relative;
  }

  .simple-menu-item::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 3px;
    background: linear-gradient(to bottom, #667eea, #764ba2);
    transform: scaleY(0);
    transition: transform 0.3s ease;
  }

  .simple-menu-item:hover::after {
    transform: scaleY(1);
  }

  .menu-item-content {
    display: flex;
    align-items: center;
    padding: 14px 20px;
    gap: 12px;
    transition: all 0.3s ease;
    position: relative;
  }

  .simple-menu-item:hover .menu-item-content {
    background: linear-gradient(135deg, #f8faff 0%, #f9f5ff 100%);
    transform: translateX(4px);
  }

  .menu-item-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    transition: all 0.3s ease;
    flex-shrink: 0;
  }

  .icon-rv-bg {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }

  .icon-home-bg {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  }

  .icon-symbol {
    display: block;
    font-size: 18px;
    line-height: 1;
  }

  .simple-menu-item:hover .menu-item-icon {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .menu-text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-left: 5px;
  }

  .simple-menu-name {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    transition: all 0.3s ease;
    color: #2d3748;
  }

  .menu-desc {
    font-size: 12px;
    color: #718096;
    transition: all 0.3s ease;
    white-space: nowrap;
  }

  .simple-menu-item:hover .simple-menu-name {
    color: #667eea;
  }

  .simple-menu-item:hover .menu-desc {
    color: #4a5568;
  }

  /* 下拉菜单项角标样式 - 带背景图效果 */
  .item-badge {
    position: absolute;
    top: 6px;
    right: 20px;
    font-size: 10px;
    padding: 3px 6px;
    border-radius: 8px;
    font-weight: 700;
    line-height: 1;
    color: white;
    z-index: 2;
  }

  .item-badge.hot {
    background: 
      radial-gradient(circle at 30% 30%, #ff6b6b 0%, #ee5a52 100%),
      url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="%23ffffff" opacity="0.3"/><circle cx="12" cy="12" r="6" fill="%23ffffff" opacity="0.5"/><circle cx="12" cy="12" r="3" fill="%23ffffff" opacity="0.7"/></svg>') no-repeat center;
    background-size: cover, 12px 12px;
    background-blend-mode: overlay;
    box-shadow: 0 2px 4px rgba(238, 90, 82, 0.3);
  }

  .item-badge.new {
    background: 
      radial-gradient(circle at 30% 30%, #4ecdc4 0%, #44a08d 100%),
      url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="%23ffffff" opacity="0.3"/><circle cx="12" cy="12" r="6" fill="%23ffffff" opacity="0.5"/><circle cx="12" cy="12" r="3" fill="%23ffffff" opacity="0.7"/></svg>') no-repeat center;
    background-size: cover, 12px 12px;
    background-blend-mode: overlay;
    box-shadow: 0 2px 4px rgba(68, 160, 141, 0.3);
  }

  /* 过渡动画 */
  .menu-slide-enter-active {
    transition: all 0.3s ease;
  }

  .menu-slide-leave-active {
    transition: all 0.2s ease;
  }

  .menu-slide-enter-from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }

  .menu-slide-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(-5px);
  }
</style>


// WEBPACK FOOTER //
// src/components/pc/Header.vue